export default __webpack_public_path__ + "static/media/star.f24f738f.png";